/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Explorer_Info_Unlock_ConfirmInputs */

const en_explorer_info_unlock_confirm = /** @type {(inputs: Explorer_Info_Unlock_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yes, unlock it`)
};

const fr_explorer_info_unlock_confirm = /** @type {(inputs: Explorer_Info_Unlock_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Oui, deverrouiller`)
};

const de_explorer_info_unlock_confirm = /** @type {(inputs: Explorer_Info_Unlock_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ja, entsperren Sie es.`)
};

const it_explorer_info_unlock_confirm = /** @type {(inputs: Explorer_Info_Unlock_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sì, sbloccalo`)
};

const ru_explorer_info_unlock_confirm = /** @type {(inputs: Explorer_Info_Unlock_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Да, разблокируйте его.`)
};

const es_explorer_info_unlock_confirm = /** @type {(inputs: Explorer_Info_Unlock_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sí, desbloquéalo`)
};

const zh_cn2_explorer_info_unlock_confirm = /** @type {(inputs: Explorer_Info_Unlock_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`是的，解锁它`)
};

const ja_explorer_info_unlock_confirm = /** @type {(inputs: Explorer_Info_Unlock_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`はい、ロックを解除します`)
};

const hi_explorer_info_unlock_confirm = /** @type {(inputs: Explorer_Info_Unlock_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`हां, इसे अनलॉक करें`)
};

const pt_pt2_explorer_info_unlock_confirm = /** @type {(inputs: Explorer_Info_Unlock_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sim, desbloqueie-o.`)
};

/**
* | output |
* | --- |
* | "Yes, unlock it" |
*
* @param {Explorer_Info_Unlock_ConfirmInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const explorer_info_unlock_confirm = /** @type {((inputs?: Explorer_Info_Unlock_ConfirmInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Explorer_Info_Unlock_ConfirmInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_explorer_info_unlock_confirm(inputs)
	if (locale === "de") return de_explorer_info_unlock_confirm(inputs)
	if (locale === "it") return it_explorer_info_unlock_confirm(inputs)
	if (locale === "ru") return ru_explorer_info_unlock_confirm(inputs)
	if (locale === "es") return es_explorer_info_unlock_confirm(inputs)
	if (locale === "zh-CN") return zh_cn2_explorer_info_unlock_confirm(inputs)
	if (locale === "ja") return ja_explorer_info_unlock_confirm(inputs)
	if (locale === "hi") return hi_explorer_info_unlock_confirm(inputs)
	if (locale === "pt-PT") return pt_pt2_explorer_info_unlock_confirm(inputs)
	return en_explorer_info_unlock_confirm(inputs)
});